import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IInitialStateLearningSettings, ILearningSettingsPayload } from "../types";

import { GetLearningSettings } from "./thunk";

const initialState: IInitialStateLearningSettings = {
    learningSettings: [],
    learningSettingsRestore: [],
    isLoadingLearningSettings: false,
    isViewLearningSettingsRestore: false,
};

const learningSettingsSlice = createSlice({
    name: "learningSettings",
    initialState,
    reducers: {
        setLearningSettings: (state, action) => {
            state.learningSettings = action.payload;
        },
        setIsViewLearningSettingsRestore: state => {
            state.isViewLearningSettingsRestore = !state.isViewLearningSettingsRestore;
        },
        updateLearningSettings: (state, action: PayloadAction<ILearningSettingsPayload>) => {
            const updateData = action.payload;

            state.learningSettings = state.learningSettings.map(elem => {
                if (elem.id === updateData.id) {
                    return {
                        ...elem,
                        ...updateData,
                    };
                }
                return elem;
            });
        },
        deletedLearningSettings: (state, action: PayloadAction<number>) => {
            const updateData = state.learningSettings.filter(elem => elem.id !== action.payload);
            state.learningSettings = updateData;
        },
        setLearningSettingsRestore: (state, action) => {
            state.learningSettingsRestore = action.payload;
        },
        deletedRestoreLearningSettings: (state, action) => {
            const updateData = state.learningSettingsRestore.filter(elem => elem.id !== action.payload);
            state.learningSettingsRestore = updateData;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(GetLearningSettings.pending, state => {
                state.isLoadingLearningSettings = true;
            })
            .addCase(GetLearningSettings.fulfilled, state => {
                state.isLoadingLearningSettings = false;
            })
            .addCase(GetLearningSettings.rejected, state => {
                state.isLoadingLearningSettings = false;
            });
    },
});

export const {
    setLearningSettings,
    setIsViewLearningSettingsRestore,
    updateLearningSettings,
    deletedLearningSettings,
    deletedRestoreLearningSettings,
    setLearningSettingsRestore,
} = learningSettingsSlice.actions;

export default learningSettingsSlice;
